import FetchData from '@shared/utils/fetchData/fetchData';

import { AddPersonalAccountInfoRequestType, PersonalAccountInfoResponseType } from '../../';

export const addPersonalAccountInfo = async (info: AddPersonalAccountInfoRequestType) => {
  return await FetchData.patch<PersonalAccountInfoResponseType>('v2/user/profile', {
    body: JSON.stringify(info)
  });
};
